import { css } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getOnboardingPlatformsCardStyles = (selected: boolean) => (theme: Theme) =>
    css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.white,
        border: `1px solid ${theme.palette.gray.ultraLight}`,
        borderRadius: theme.borderRadius.M,
        cursor: 'pointer',
        height: 80,
        maxWidth: 160,
        padding: theme.spacing(2),
        ...theme.elevations.flat1,

        ':hover': {
            borderColor: theme.palette.primary.main,
        },

        ...(selected && {
            backgroundColor: theme.palette.primary.ultraLight,
            borderColor: theme.palette.primary.main,
        }),
    });

export const getLogoStyles = () =>
    css({
        maxHeight: 30,
        maxWidth: 130,
        objectFit: 'contain',
        width: '100%',
        height: 'auto',
    });

export const getTextStyles = () =>
    css({
        textAlign: 'center',
    });
